export enum FilterRangeType {
  MIN = "MIN",
  MAX = "MAX",
}

export type FilterByRange<T> = {
  minValueId: T | null;
  maxValueId: T | null;
};
